module.exports = __webpack_public_path__ + "static/img/Horizontal.650f2e98.png";